// Payment system types

// Тип оплаты группы
export type PaymentType = 'monthly_unlimited' | 'monthly_limited' | 'pay_per_session' | 'flexible' | 'none'

// Метод оплаты
export type PaymentMethod = 'cash' | 'transfer' | 'card' | 'other'

// Статус оплаты спортсмена
export type PaymentStatus = 'paid' | 'overdue' | 'low_balance' | 'no_balance' | 'not_set'

// Настройки оплаты группы
export interface GroupPaymentSettings {
  id: string
  group_id: string
  payment_type: PaymentType
  monthly_price?: string  // decimal as string
  sessions_per_month?: number
  price_per_session?: string  // decimal as string
  currency: string
  created_at: string
  updated_at: string
}

// Эффективные настройки оплаты спортсмена (групповые или индивидуальные)
export interface EffectivePaymentSettings {
  payment_type: PaymentType
  monthly_price?: string
  sessions_per_month?: number
  price_per_session?: string
  currency: string
  is_override: boolean
  override_reason?: string
}

// Платёж
export interface Payment {
  id: string
  athlete_id: string
  group_id: string
  amount: string  // decimal as string
  payment_date: string
  payment_method: PaymentMethod
  paid_for_month?: string
  sessions_purchased?: number
  comment?: string
  created_at: string
  created_by?: string
  deleted_at?: string
}

// Статус оплаты спортсмена
export interface PaymentStatusResponse {
  athlete_id: string
  status: PaymentStatus
  last_paid_month?: string
  sessions_remaining?: number
  last_payment_date?: string
  last_payment_amount?: string
}

// Запросы

export interface CreateGroupPaymentSettingsRequest {
  payment_type: PaymentType
  monthly_price?: string
  sessions_per_month?: number
  price_per_session?: string
  currency?: string
}

export interface RecordPaymentRequest {
  amount: string
  payment_date: string
  payment_method: PaymentMethod
  paid_for_month?: string
  sessions_purchased?: number
  comment?: string
  created_by?: string
}

// Хелперы

export const PAYMENT_TYPE_LABELS: Record<PaymentType, string> = {
  monthly_unlimited: 'Месячный абонемент',
  monthly_limited: 'Абонемент с занятиями',
  pay_per_session: 'Разовое занятие',
  flexible: 'Произвольная оплата',
  none: 'Не настроено',
}

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Наличные',
  transfer: 'Перевод',
  card: 'Карта',
  other: 'Другое',
}

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  paid: 'Оплачено',
  overdue: 'Просрочено',
  low_balance: 'Мало занятий',
  no_balance: 'Нет занятий',
  not_set: 'Не настроено',
}

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  paid: 'text-green-600 bg-green-100',
  overdue: 'text-red-600 bg-red-100',
  low_balance: 'text-orange-600 bg-orange-100',
  no_balance: 'text-red-600 bg-red-100',
  not_set: 'text-gray-500 bg-gray-100',
}

export const PAYMENT_STATUS_ICONS: Record<PaymentStatus, string> = {
  paid: '✅',
  overdue: '❌',
  low_balance: '⚠️',
  no_balance: '❌',
  not_set: '—',
}

export function formatAmount(amount: string, currency = 'RUB'): string {
  const num = parseFloat(amount)
  if (isNaN(num)) return '—'
  return `${num.toLocaleString('ru-RU')} ${currency === 'RUB' ? '₽' : currency}`
}

export function formatMonth(dateStr: string): string {
  const date = new Date(dateStr)
  return date.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' })
}
